export default __webpack_public_path__ + "static/media/demand.7c4c7ab0.png";